import React from 'react';
import { Styled } from './InlineLoader.styles';
import { useSettingsState } from '../../context/SettingsContext';

const InlineLoader = ({ inline, color, size = 40, light = false }) => {
  const { theme } = useSettingsState();

  return (
    <Styled.Loader
      inline={inline}
      color={color || theme.primaryColor}
      size={size}
    >
      <svg viewBox="0 0 50 50">
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth={light ? '3' : '5'}
        />
      </svg>
    </Styled.Loader>
  );
};

export default InlineLoader;
